import type { ICinematics } from '@/types'
import { isEmpty } from '@/utils/nunchee-kit'

/** Shared client/server predicate for the NEXT_PUBLIC_LOCAL_CINEMATICS dev override (see docs/CINEMATIC.md) */
export const shouldUseLocalCinematics = (localCinematics: ICinematics | undefined): boolean =>
  process.env.NODE_ENV === 'development' &&
  process.env.NEXT_PUBLIC_LOCAL_CINEMATICS === 'true' &&
  localCinematics !== undefined &&
  !isEmpty(localCinematics)
